import { useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Testimonials from "./pages/Testimonials";
import { INITIAL_GALLERY, INITIAL_TESTIMONIALS } from "./data/constants";

export default function App() {
  const [page, setPage] = useState("Home");
  const [gallery, setGallery] = useState(INITIAL_GALLERY);
  const [adminMode, setAdminMode] = useState(false);
  const [testimonials, setTestimonials] = useState(INITIAL_TESTIMONIALS);

  const navigate = (p) => { setPage(p); window.scrollTo(0, 0); };

  return (
    <div className="app">
      <Navbar page={page} navigate={navigate} />
      {page === "Home"         && <Home navigate={navigate} />}
      {page === "Services"     && <Services />}
      {page === "Gallery"      && <Gallery gallery={gallery} setGallery={setGallery} adminMode={adminMode} setAdminMode={setAdminMode} />}
      {page === "About"        && <About />}
      {page === "Contact"      && <Contact />}
      {page === "Testimonials" && <Testimonials testimonials={testimonials} setTestimonials={setTestimonials} />}
      <Footer navigate={navigate} />
    </div>
  );
}